module.exports = __webpack_public_path__ + "static/img/englishCourse.cba16be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/englishCourse.png
// module id = Gdua
// module chunks = 1